module.exports = __webpack_public_path__ + "img/staff.157a2d37.png";